// @flow

import React from 'react';

import { ButtonWrapper, VIEW_TYPE } from 'client/components/preRegistration/preRegistration';
import { PRE_REG_START } from 'client/constants/amplitudeTracker';

import { Tracking } from 'web-core/src/tracking';

type Props = {
  ctaBtn: string,
  header: string,
  setView: Function,
  subheader: string,
};

const Start = (props: Props) => {
  const { ctaBtn, header, setView, subheader } = props;
  const handleClick = () => {
    Tracking.track(PRE_REG_START);
    setView(VIEW_TYPE.REGISTRATION_FORM);
  };
  return (
    <React.Fragment>
      <h1>{header}</h1>
      <h3>{subheader}</h3>
      <ButtonWrapper clickHandler={handleClick}>{ctaBtn}</ButtonWrapper>
    </React.Fragment>
  );
};

export default Start;
